import { loggedUserSelector } from '@myre/ui-domain-core';

import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { type Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { LeaveAdmin } from '../admin/store/admin.actions';
import { type RootState } from '../core/core.module';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard {
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _store$ = inject<Store<RootState>>(Store);

  public canActivate(): Observable<boolean> {
    return this._store$.pipe(
      select(loggedUserSelector),
      first(a => Boolean(a)),
      map(loggedUser => {
        if (
          !this._authService.isAuth ||
          !loggedUser.email.endsWith('@myre.fr')
        ) {
          void this._router.navigate(['/login']);

          return false;
        }

        return true;
      }),
    );
  }

  public canDeactivate(): boolean {
    this._store$.dispatch(new LeaveAdmin());

    return true;
  }
}
